/* eslint-disable max-len */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { images, imgUrl } from '../../utils/consts';

interface INeedHelp {
  cardNumber: string;
  imagePath?: string;
}

const NeedHelp: React.FC<INeedHelp> = ({ cardNumber, imagePath }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-8">
      <div className="sui-flex sui-flex-col sui-items-center sui-gap-2">
        <img
          className="sui-rounded-md"
          src={imagePath || `${imgUrl.host}${imgUrl.pathname}${images[0]}`}
          alt="gift-card-image"
          height="180"
          width="320"
          data-testid="help-gc-image"
        />
        <Typography weight="bold">
          {`**** ${cardNumber?.slice(0, 6)} ${cardNumber?.slice(6)} *******`}
        </Typography>
      </div>
      <Typography>
        If you misplaced your Gift Card or if your Gift Card was lost or stolen, contact Customer Care immediately at 1-800-HOME-DEPOT (1-800-466-3337).
      </Typography>
      <Typography>
        If your Gift Card has not been redeemed or has some remaining value, we can cancel the original and reissue a new Gift Card. To reissue the Gift Card for the remaining value, you must provide valid proof of purchase, unless otherwise allowed by your state.
      </Typography>
    </div>
  );
};

export { NeedHelp };
